import { WithLabel } from "./withLabel";

export const SwitchCompositions = {
    WithLabel,
};

export type { WithLabelProps as SwitchWithLabelProps } from "./withLabel";
